import { DELETE_NOTIFICATION, RESET_NOTIFICATIONS } from '../types'

export const resetNotifications = () => dispatch => dispatch({ type: RESET_NOTIFICATIONS })

export const deleteNotification = key => dispatch => dispatch({ type: DELETE_NOTIFICATION, payload: key })
